var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:["uhv-play", ("uhv-play--" + _vm.size)],attrs:{"type":"button"},on:{"click":function($event){_vm.$emit('click')}}},[_c('uhv-svg-icon',{attrs:{"icon":"play"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }